/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks.index'
import { Route as SalesIndexRouteImport } from './routes/sales.index'
import { Route as TasksTableRouteImport } from './routes/tasks.table'
import { Route as TasksStatsRouteImport } from './routes/tasks.stats'
import { Route as TasksBoardRouteImport } from './routes/tasks.board'
import { Route as SalesStatsRouteImport } from './routes/sales.stats'
import { Route as SalesPipelineRouteImport } from './routes/sales.pipeline'
import { Route as SalesOpportunitiesRouteImport } from './routes/sales.opportunities'
import { Route as SalesLeadsRouteImport } from './routes/sales.leads'

const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesRoute = SalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TasksRoute,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesRoute,
} as any)
const TasksTableRoute = TasksTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => TasksRoute,
} as any)
const TasksStatsRoute = TasksStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => TasksRoute,
} as any)
const TasksBoardRoute = TasksBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => TasksRoute,
} as any)
const SalesStatsRoute = SalesStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => SalesRoute,
} as any)
const SalesPipelineRoute = SalesPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => SalesRoute,
} as any)
const SalesOpportunitiesRoute = SalesOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => SalesRoute,
} as any)
const SalesLeadsRoute = SalesLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => SalesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRouteWithChildren
  '/sales/leads': typeof SalesLeadsRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/stats': typeof SalesStatsRoute
  '/tasks/board': typeof TasksBoardRoute
  '/tasks/stats': typeof TasksStatsRoute
  '/tasks/table': typeof TasksTableRoute
  '/sales/': typeof SalesIndexRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/sales/leads': typeof SalesLeadsRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/stats': typeof SalesStatsRoute
  '/tasks/board': typeof TasksBoardRoute
  '/tasks/stats': typeof TasksStatsRoute
  '/tasks/table': typeof TasksTableRoute
  '/sales': typeof SalesIndexRoute
  '/tasks': typeof TasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRouteWithChildren
  '/sales/leads': typeof SalesLeadsRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/stats': typeof SalesStatsRoute
  '/tasks/board': typeof TasksBoardRoute
  '/tasks/stats': typeof TasksStatsRoute
  '/tasks/table': typeof TasksTableRoute
  '/sales/': typeof SalesIndexRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sales'
    | '/settings'
    | '/tasks'
    | '/sales/leads'
    | '/sales/opportunities'
    | '/sales/pipeline'
    | '/sales/stats'
    | '/tasks/board'
    | '/tasks/stats'
    | '/tasks/table'
    | '/sales/'
    | '/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/sales/leads'
    | '/sales/opportunities'
    | '/sales/pipeline'
    | '/sales/stats'
    | '/tasks/board'
    | '/tasks/stats'
    | '/tasks/table'
    | '/sales'
    | '/tasks'
  id:
    | '__root__'
    | '/'
    | '/sales'
    | '/settings'
    | '/tasks'
    | '/sales/leads'
    | '/sales/opportunities'
    | '/sales/pipeline'
    | '/sales/stats'
    | '/tasks/board'
    | '/tasks/stats'
    | '/tasks/table'
    | '/sales/'
    | '/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SalesRoute: typeof SalesRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  TasksRoute: typeof TasksRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales': {
      id: '/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof SalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof TasksRoute
    }
    '/sales/': {
      id: '/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof SalesRoute
    }
    '/tasks/table': {
      id: '/tasks/table'
      path: '/table'
      fullPath: '/tasks/table'
      preLoaderRoute: typeof TasksTableRouteImport
      parentRoute: typeof TasksRoute
    }
    '/tasks/stats': {
      id: '/tasks/stats'
      path: '/stats'
      fullPath: '/tasks/stats'
      preLoaderRoute: typeof TasksStatsRouteImport
      parentRoute: typeof TasksRoute
    }
    '/tasks/board': {
      id: '/tasks/board'
      path: '/board'
      fullPath: '/tasks/board'
      preLoaderRoute: typeof TasksBoardRouteImport
      parentRoute: typeof TasksRoute
    }
    '/sales/stats': {
      id: '/sales/stats'
      path: '/stats'
      fullPath: '/sales/stats'
      preLoaderRoute: typeof SalesStatsRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/pipeline': {
      id: '/sales/pipeline'
      path: '/pipeline'
      fullPath: '/sales/pipeline'
      preLoaderRoute: typeof SalesPipelineRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/opportunities': {
      id: '/sales/opportunities'
      path: '/opportunities'
      fullPath: '/sales/opportunities'
      preLoaderRoute: typeof SalesOpportunitiesRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/leads': {
      id: '/sales/leads'
      path: '/leads'
      fullPath: '/sales/leads'
      preLoaderRoute: typeof SalesLeadsRouteImport
      parentRoute: typeof SalesRoute
    }
  }
}

interface SalesRouteChildren {
  SalesLeadsRoute: typeof SalesLeadsRoute
  SalesOpportunitiesRoute: typeof SalesOpportunitiesRoute
  SalesPipelineRoute: typeof SalesPipelineRoute
  SalesStatsRoute: typeof SalesStatsRoute
  SalesIndexRoute: typeof SalesIndexRoute
}

const SalesRouteChildren: SalesRouteChildren = {
  SalesLeadsRoute: SalesLeadsRoute,
  SalesOpportunitiesRoute: SalesOpportunitiesRoute,
  SalesPipelineRoute: SalesPipelineRoute,
  SalesStatsRoute: SalesStatsRoute,
  SalesIndexRoute: SalesIndexRoute,
}

const SalesRouteWithChildren = SalesRoute._addFileChildren(SalesRouteChildren)

interface TasksRouteChildren {
  TasksBoardRoute: typeof TasksBoardRoute
  TasksStatsRoute: typeof TasksStatsRoute
  TasksTableRoute: typeof TasksTableRoute
  TasksIndexRoute: typeof TasksIndexRoute
}

const TasksRouteChildren: TasksRouteChildren = {
  TasksBoardRoute: TasksBoardRoute,
  TasksStatsRoute: TasksStatsRoute,
  TasksTableRoute: TasksTableRoute,
  TasksIndexRoute: TasksIndexRoute,
}

const TasksRouteWithChildren = TasksRoute._addFileChildren(TasksRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SalesRoute: SalesRouteWithChildren,
  SettingsRoute: SettingsRoute,
  TasksRoute: TasksRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
